import { values } from '../_helpers'

const _enum = {
  short: 0,
  mediumMinus: 1,
  medium: 2,
  mediumPlus: 3,
  long: 4
}

const finish = { ..._enum, name: 'finish', values: values(_enum) }

export {
  finish
}
